import { defineMessages } from 'react-intl';

export const messages: {
	cornerRadius: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cornerRadius: {
		id: 'company-hub.carousel-extension.config.corner.radius',
		defaultMessage: 'Corners',
		description: 'Text labeling a customization option for corner radius',
	},
});
